<button [routerLink]="routerLink"
  class="diagonal-swipe relative overflow-hidden rounded-md 3xl:rounded-lg group {{ sizeClass }}"
  [ngClass]="{'white-bg': bg === 'white', 'teal-bg': bg === 'teal-bg'}">
  <span class="relative -z-10 group-hover:text-white transition-all duration-300 ease-in-out flex items-center">
    {{ heading }}
    <ng-container *ngIf="icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-5 h-5 ml-4 sm:ml-6 3xl:ml-8 fill-current transition-colors duration-300"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
    </ng-container>
  </span>
</button>
